const KEY = "be_recently_viewed";
const MAX = 8;

export function pushRecentlyViewed(course) {
  if (!course || !course.id) return;
  try {
    const cur = JSON.parse(localStorage.getItem(KEY) || "[]");
    const next = [
      { id: course.id, slug: course.slug, title: course.title, image_url: course.image_url, price: course.price, ts: Date.now() },
      ...cur.filter((c) => c.id !== course.id),
    ].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* localStorage unavailable */
  }
}

export function getRecentlyViewed() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}
